import React, { Component } from 'react';
import counterData from "../../data/mainData.json";

class CounterV1 extends Component {
  render() {
    return (
      <div className="ltn__counterup-area section-bg-1 pt-50 pb-0">
        <div className="container">
          <div className="row">
            {counterData.counter.items.map((item, index) => (
              <div key={index} className="col-md-3 col-sm-6 align-self-center">
                <div className="ltn__counterup-item text-color-white---">
                  <div className="counter-icon">
                    <i className={item.icon} />
                  </div>
                  <h1>
                    <span className="counter">{item.value}</span>
                    <span className="counterUp-icon">{item.suffix}</span>
                  </h1>
                  <h6>{item.label}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CounterV1;
